import { useEffect } from 'react';
import { useObservable } from 'thrive-observable-react';
import { infiniteScroll } from '../utility/infiniteScroll';

//service
import { PS } from '../service/PeopleSearch.Service';
import { CAS } from '../service/ChatConfig.Service';

//components
import { PeopleSearchResults } from '../components/peopleSearch/PeopleSearchResults';
import { SearchBar } from 'thrive-components';

//styling
import '../styles/PeopleSearch.scss';



export function PeopleSearch() {
    const searchInput = useObservable(PS.getSearchInputString());
    const countMessage = useObservable(PS.getResultsMessage());
    const searchResults = useObservable(PS.searchResults);
    const isLoading = useObservable(PS.getIsLoading());
    const isLoadingMore = useObservable(PS.getIsLoadingMore());
    const hasMorePeople = useObservable(PS.peopleSearchPaginationUri);
    const infiniteScrollRef = infiniteScroll(() => PS.getMorePeopleSearch(), hasMorePeople) ?? undefined;

    useEffect(() => {
        PS.init();

        return () => {
            PS.cleanUp();
        }
    }, []);

    return (
        <div id='chat-people-search-container'>
            <div id='people-search-bar'>
                <SearchBar
                    className={"people-search-bar-input"}
                    searchInput={searchInput ?? ""} 
                    setSearchInput={(input: string) => PS.setSearchInput(input)} 
                    onClickSearch={() => PS.getPeopleSearch()} 
                    placeholderText={CAS.localisationStrings.SearchByNameOrJobRole()}
                    ariaLabel={CAS.localisationStrings.SearchByNameOrJobRole()}
                    buttonLabel={CAS.localisationStrings.Search()}
                    buttonIconColor='var(--chatFontColor)'
                />
            </div>

            <PeopleSearchResults 
                countMessage={countMessage} 
                searchResults={searchResults}
                isLoading={isLoading}
                isLoadingMore={isLoadingMore}
                infiniteScrollRef={infiniteScrollRef}
            /> 
        </div>
    );
};

export default PeopleSearch;
